<template>
  <!-- Wrapper de panel flotante REUTILIZABLE (derecho, altura completa). Da el chrome
       común (cabecera con título + cerrar, cuerpo scrollable) y un ancho por defecto
       configurable. Sobre él se montan distintos contenidos por el slot (info del
       parque, info del elemento seleccionado, etc.). -->
  <div class="epc-panel" :style="{ width: resolvedWidth }">
    <div class="epc-panel-header">
      <slot name="header">
        <span class="epc-panel-title">{{ title }}</span>
      </slot>
      <button type="button" class="epc-panel-close" :aria-label="$t('close')"
        @click="$emit('epc-close')">
        <b-icon icon="xmark" pack="fas" size="is-small"></b-icon>
      </button>
    </div>

    <div class="epc-panel-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetPanel",

  props: {
    title: { type: String, default: null },
    // Ancho predeterminado; número = px. Un contenido puede pedir otro ancho.
    width: { type: [Number, String], default: 620 },
  },

  computed: {
    resolvedWidth() {
      return typeof this.width === 'number' ? this.width + 'px' : this.width
    },
  },
}
</script>

<style scoped>
.epc-panel {
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  z-index: 8;
  max-width: calc(100vw - 20px);
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #e9e9ef;
  border-radius: 12px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.14);
  overflow: hidden;
}

.epc-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #eef0f4;
}

.epc-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #343a40;
}

.epc-panel-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #868e96;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}

.epc-panel-close:hover {
  background-color: #f2f2f7;
  color: #3a6bc8;
}

.epc-panel-body {
  position: relative;
  flex: 1;
  overflow-y: auto;
  padding: 12px 14px;
}
</style>
